export default __webpack_public_path__ + "static/media/Helm of the Membranous.7b81b801.jpg";